import { createContext, ReactNode } from 'react'
import { TwoFASettingPage } from 'pages/MyAccountEdit/TwoFASettingPage'
import { useSubdomainInfo } from 'shared/Site/api'
import { useCurrentUser } from 'utils/hooks/useCurrentUser'
import { useIsLuckyBirdUser } from 'utils/hooks/useIsLuckyBirdUser'

type TwoFAType = {}

export const TwoFAContext = createContext<TwoFAType | null>(null)
export const TwoFaConsumer = TwoFAContext.Consumer

type Props = {
  children: ReactNode
}

export const TwoFAProvider = ({ children }: Props) => {
  const user = useCurrentUser()
  const { data } = useSubdomainInfo()
  const { isLuckyBird } = useIsLuckyBirdUser()
  const notAuthenticated = !user
  const haveTwoFASettings =
    (!!user?.two_factor_authentication &&
      user?.two_factor_authentication?.length > 0 &&
      data?.data?.subscriber?.two_factor_authentication) ||
    !data?.data?.subscriber?.two_factor_authentication

  return (
    <TwoFAContext.Provider value={{}}>
      {notAuthenticated || haveTwoFASettings || isLuckyBird ? children : <TwoFASettingPage />}
    </TwoFAContext.Provider>
  )
}
